import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MATERIAL_ICON_LANGUAGE } from '../../../shared/common/Button/Icon';
import { URL_FOREIGN_LANGUAGE_ROUTE, URL_LANGUAGE_LEARNING_ROUTE, URL_LOTE_ROUTE } from '../constants';
import { DropDownMenu } from '../../../shared/common/DropDownMenu';
import { useTranslation } from 'react-i18next';

const StDropDown = styled(DropDownMenu)`
    font-size: 20px;
    && a {
        display: flex;
        font-size: 20px;
    }

    && .default-dd {
        top: 30px;
    }

    && .active-arrow {
        right: unset !important;
        left: 80px;
    }
`;

const StNavLink = styled(Link)`
    white-space: nowrap !important;
    font-size: 16px !important;
    padding: 4px 8px 4px 8px !important;
`;
interface Props {
    isInLanguageLearning?: boolean;
    className?: string;
}
const LanguageNavigationDropdown: FC<Props> = props => {
    const { t } = useTranslation();
    const label = props.isInLanguageLearning
        ? `${t('menu.shop.languages.languageLearning')}`
        : `${t('menu.shop.languages.lote')}`;
    const icon = <i className="material-icons">{MATERIAL_ICON_LANGUAGE}</i>;

    const [expanded, setExpanded] = useState(false);

    return (
        <StDropDown
            showAsButton={false}
            expanded={expanded}
            onToggleClick={() => setExpanded(!expanded)}
            align="left"
            gap={2}
            onClickOutside={() => setExpanded(false)}
            label={label}
            className={props.className}
            iconCode={MATERIAL_ICON_LANGUAGE}
            iconDefaultClasses="material-icons material-label-icon"
        >
            <li>
                <StNavLink to={`/${URL_FOREIGN_LANGUAGE_ROUTE}/${URL_LOTE_ROUTE}`}>
                    {icon} {t('menu.shop.languages.lote')}
                </StNavLink>
            </li>
            <li>
                <StNavLink to={`/${URL_FOREIGN_LANGUAGE_ROUTE}/${URL_LANGUAGE_LEARNING_ROUTE}`}>
                    {icon} {t('menu.shop.languages.languageLearning')}
                </StNavLink>
            </li>
        </StDropDown>
    );
};

export default LanguageNavigationDropdown;
